var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9357 9.15195C19.7222 9.35432 19.7207 9.68004 19.9372 9.88241L21.1172 10.9836L17.5505 10.9836C17.2468 10.9836 17 11.2151 17 11.5C17 11.7848 17.2468 12.0163 17.5505 12.0163L21.1172 12.0163L19.9372 13.1182C19.7207 13.3199 19.7222 13.6463 19.9357 13.848C20.15 14.0503 20.498 14.0503 20.7138 13.85L22.8389 11.8659L22.8389 11.8652C22.8892 11.8181 22.9298 11.7619 22.9579 11.6989C22.9852 11.6365 23 11.5686 23 11.5C23 11.4307 22.9852 11.3627 22.9571 11.3004C22.9298 11.2387 22.8892 11.1825 22.8397 11.1354L22.8389 11.134L20.7138 9.15056C20.498 8.94958 20.15 8.94958 19.9357 9.15195Z",
    fill: "#136BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.0156C5.45422 15.0156 2 15.6625 2 18.2467C2 20.83 5.4332 21.5001 9.5 21.5001C13.5448 21.5001 17 20.8533 17 18.269C17 15.6848 13.5668 15.0156 9.5 15.0156Z",
    fill: "#136BFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.49974 12.5542C12.2543 12.5542 14.4624 10.3177 14.4624 7.52761C14.4624 4.73754 12.2543 2.5 9.49974 2.5C6.74517 2.5 4.53711 4.73754 4.53711 7.52761C4.53711 10.3177 6.74517 12.5542 9.49974 12.5542Z",
    fill: "#136BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.a2575129527bd59623fc258efb5dfd53.svg";
export { ForwardRef as ReactComponent };